/* Meta Lead for storefront enquiries. Campaign pages retain their existing Google/Meta/CRM trigger. */
(function (w, d) {
  'use strict';
  const page = new URL(w.location.href);
  const campaigns = ['corporate-gifts-campaign', 'staff-gifts', 'client-gifts',
    'corporate-christmas-gifts', 'staff-christmas-gifts', 'client-christmas-gifts'];
  if (page.origin !== 'https://www.croweandco.co.nz' ||
      campaigns.some(path => page.pathname === '/pages/' + path) ||
      page.searchParams.has('preview_theme_id') || page.searchParams.has('view') ||
      w.Shopify?.designMode || (w.Shopify?.theme?.role && w.Shopify.theme.role !== 'main') ||
      w.__croweMetaEnquiry) return;

  const state = w.__croweMetaEnquiry = {installed: true, pixelId: '540297263439908',
    leadQueued: false, status: 'idle', source: null};
  const storageKey = 'crowe.meta.enquiry.pending.v1';
  const nativeLifetime = 30 * 60 * 1000;
  let pending = null, privacyLoading = false, timer = null, initialised = false, scriptWatched = false;
  function allowed() {
    try {
      return w.Shopify?.customerPrivacy?.marketingAllowed() === true &&
        w.Shopify?.customerPrivacy?.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function readSubmission() {
    try {
      const record = JSON.parse(w.sessionStorage.getItem(storageKey));
      if (record && /^[\da-f]{8}(-[\da-f]{4}){3}-[\da-f]{12}$/i.test(record.id) &&
          typeof record.formId === 'string' && record.path === page.pathname &&
          Number.isFinite(record.at) && record.at <= Date.now() && Date.now() - record.at < nativeLifetime) return record;
    } catch (_) { /* Storage may be unavailable; the form must still work. */ }
    return null;
  }
  // Read only at page entry. A submit on a page with an old success message
  // cannot count until Shopify returns a new page confirming that submission.
  const returnedSubmission = readSubmission();
  function nativeSuccess() {
    if (pending || !returnedSubmission) return;
    const confirmed = Array.from(d.querySelectorAll('[data-crowe-enquiry-success]')).some(node => {
      const form = node.closest('form');
      return form && form.id === returnedSubmission.formId &&
        form.querySelector('input[name="form_type"]')?.value === 'contact';
    });
    if (confirmed) pending = {id: returnedSubmission.id, source: 'shopify-contact', expires: Date.now() + 10000};
  }
  function rememberSubmission(event) {
    try {
      const form = event.target;
      if (!allowed() || form?.tagName !== 'FORM' || !form.id ||
          form.querySelector('input[name="form_type"]')?.value !== 'contact' ||
          !form.querySelector('[name="contact[body]"]') || form.method.toLowerCase() !== 'post') return;
      const action = new URL(form.action, page);
      if (action.origin !== page.origin || !/(^|\/)contact$/.test(action.pathname)) return;
      // Store only a random event ID and form location, never field values.
      w.sessionStorage.setItem(storageKey, JSON.stringify({id: w.crypto.randomUUID(),
        formId: form.id, path: page.pathname, at: Date.now()}));
    } catch (_) { /* No change to submission or validation. */ }
  }
  function forgetSubmission() {
    if (pending?.source !== 'shopify-contact') return;
    try {
      if (JSON.parse(w.sessionStorage.getItem(storageKey))?.id === pending.id) w.sessionStorage.removeItem(storageKey);
    } catch (_) {}
  }
  function retry() {
    if (timer || !pending || Date.now() >= pending.expires || state.leadQueued || state.status === 'load_failed') return;
    timer = w.setTimeout(() => { timer = null; check(); }, 250);
  }
  function queueLead() {
    if (state.leadQueued || !allowed() || state.status === 'load_failed') return;
    try {
      if (typeof w.fbq !== 'function') {
        const fbq = w.fbq = function () {
          if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
          else fbq.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = fbq;
        fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
      }
      if (typeof w.fbq.callMethod !== 'function') {
        state.status = 'loading';
        if (!scriptWatched) {
          scriptWatched = true;
          let script = d.querySelector('script[src*="connect.facebook.net"][src*="/fbevents.js"]');
          const created = !script;
          if (created) {
            script = d.createElement('script');
            script.async = true;
            script.src = 'https://connect.facebook.net/en_US/fbevents.js';
          }
          script.addEventListener('load', check, {once: true});
          script.addEventListener('error', () => { state.status = 'load_failed'; }, {once: true});
          if (created) d.head.appendChild(script);
        }
        retry();
        return;
      }
      if (!initialised) {
        const pixels = w.fbq.getState?.().pixels || [];
        if (!pixels.some(pixel => String(pixel.id) === state.pixelId)) {
          w.fbq('set', 'autoConfig', false, state.pixelId);
          w.fbq('init', state.pixelId);
        }
        initialised = true;
      }
      w.fbq('trackSingle', state.pixelId, 'Lead', {}, {eventID: pending.id});
      state.leadQueued = true;
      state.status = 'queued';
      state.source = pending.source;
      forgetSubmission();
    } catch (_) { state.status = 'error'; }
  }
  function qikifySuccessVisible() {
    const node = d.querySelector('.bcontact-550592 .bcontact-success-notification');
    return !!node && node.getClientRects().length > 0;
  }
  function check() {
    nativeSuccess();
    if (!pending || Date.now() > pending.expires ||
        (pending.source === 'qikify-550592' && !qikifySuccessVisible())) return;
    queueLead();
  }
  function loadPrivacy() {
    if (w.Shopify?.customerPrivacy) return check();
    if (!privacyLoading && w.Shopify?.loadFeatures) {
      privacyLoading = true;
      w.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (!error) check();
      });
    }
  }
  function target(url, method) {
    try {
      const request = new URL(url, page);
      return String(method || 'GET').toUpperCase() === 'POST' &&
        request.origin === 'https://api.qikify.com' && request.pathname === '/merchant/contactform/submissions' &&
        request.searchParams.get('shop') === 'croweandco.myshopify.com' && request.searchParams.get('entry_id') === '550592';
    } catch (_) { return false; }
  }
  function accept(status, text, alreadySuccessful) {
    try {
      if (alreadySuccessful || status < 200 || status >= 300 || pending) return;
      const response = JSON.parse(text);
      if (!response || typeof response !== 'object' || Array.isArray(response) ||
          response.error || response.errors || response.success === false ||
          (response.statusCode != null && !(Number(response.statusCode) >= 200 && Number(response.statusCode) < 300))) return;
      pending = {id: w.crypto.randomUUID(), source: 'qikify-550592', expires: Date.now() + 10000};
      check();
    } catch (_) { /* Observe only; Qikify owns the submission and its response. */ }
  }
  const originalFetch = w.fetch;
  w.fetch = function (input, init) {
    let watch = false, alreadySuccessful = false;
    try {
      watch = target(typeof input === 'string' || input instanceof URL ? String(input) : input.url,
        init?.method || input?.method);
      if (watch) alreadySuccessful = qikifySuccessVisible();
    } catch (_) {}
    const result = originalFetch.apply(this, arguments);
    if (watch) result.then(response => response.clone().text().then(text => accept(response.status, text, alreadySuccessful))).catch(() => {});
    return result;
  };
  const proto = w.XMLHttpRequest.prototype, open = proto.open, send = proto.send;
  const requests = new WeakMap();
  proto.open = function (method, url) {
    requests.set(this, target(url, method));
    return open.apply(this, arguments);
  };
  proto.send = function () {
    try {
      if (requests.get(this)) {
        const alreadySuccessful = qikifySuccessVisible();
        this.addEventListener('load', () => {
          try { accept(this.status, this.responseText, alreadySuccessful); } catch (_) {}
        }, {once: true});
      }
    } catch (_) {}
    return send.apply(this, arguments);
  };
  d.addEventListener('submit', rememberSubmission, true);
  new MutationObserver(check).observe(d.documentElement, {childList: true, subtree: true,
    attributes: true, attributeFilter: ['style', 'class', 'hidden']});
  d.addEventListener('visitorConsentCollected', check);
  d.addEventListener('DOMContentLoaded', loadPrivacy, {once: true});
  w.addEventListener('load', loadPrivacy, {once: true});
  loadPrivacy();
})(window, document);
